<script>
export default {
  name: "AppActivityLog",

  props: {
    items: { type: Array, default: ()=>[] },
    regType: { type: String, default: '' },
  },
}
</script>

<template>
  <div>
    <!-- Empty -->
    <div v-if="!items.length">N/A</div>
    <!-- Activity Logs -->
    <ul
      v-else
      class="activity-feed mb-0 ps-2"
      :class="{ 'scrollable': items.length > 4 }"
    >
      <li
        v-for="(item,key) in items"
        :key="key"
        class="feed-item pb-1"
      >
          <div class="feed-item-list">

            <p v-if="['CMP', 'event'].includes(regType)" class="text-muted mb-1">{{ item.date_created }}</p>
            <p v-if="regType !== 'CMP'" class="text-muted mb-1">{{ item.log_date }}</p>

            <p v-if="['CMP', 'event'].includes(regType)" class="text-muted font-size-12">
              <span class="text-primary">{{ item.user.name }}</span>&nbsp;{{ item.description }}
            </p>

            <p v-if="!['CMP', 'event'].includes(regType)" class="text-muted font-size-12">
              <span class="text-primary">{{ item.name }}</span>&nbsp;{{ item.description }}
            </p>
			
          </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.activity-feed {
  &.scrollable {
    // max-height: 410px;
    max-height: 190px;
    overflow-y: scroll;
    
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    &::-webkit-scrollbar:vertical {
      width: 10px;
    }
    &::-webkit-scrollbar:horizontal {
      height: 10px;
    }
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-thumb {
      background-color: #cdd3d8;
      border-radius: 0.3rem;
      border: 2px solid #ffffff;
    }
    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-track {
      border-top-right-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
      background-color: #ffffff;
    }
  }
}

@media (max-width: 1200px) {
  .activity-feed {
    &.scrollable {
      max-height: 320px;
    }
  }
}
</style>